export default __webpack_public_path__ + "static/media/github.a4e6bc67.svg";